import {
  ReferralButton,
  ReferralIcon,
  IconButton,
  useBreakpointValue,
} from "@alchemy/ui";

import useBoolean from "../../hooks/useBoolean";

import ReferralModal from "../referral-flow/ReferralModal";

const HeaderReferralButton = () => {
  const showReferralModalBool = useBoolean();

  const referralButtonSm = (
    <IconButton onClick={showReferralModalBool.setTrue} padding="sm">
      <ReferralIcon animate />
    </IconButton>
  );

  const referralButtonLg = (
    <ReferralButton onClick={showReferralModalBool.setTrue}>
      Get $100+
    </ReferralButton>
  );

  const referralButton = useBreakpointValue({
    base: referralButtonSm,
    sm: referralButtonLg,
    md: referralButtonSm,
    lg: referralButtonLg,
  });

  return (
    <>
      {referralButton}

      <ReferralModal
        isOpen={showReferralModalBool.value}
        onClose={showReferralModalBool.setFalse}
        source="navbar-button"
      />
    </>
  );
};

export default HeaderReferralButton;
